ConfirmDialog = App.loadClass('core::ConfirmDialog')
Controller = App.loadClass 'core::Angular/Controller'

class exports.DaystoharvestController extends Controller
    constructor: (@scope, @transitions, @days, @repo, @loader) ->
        super(@scope, @transitions)
        @scope.title = 'Days to Harvest'
        @scope.fullpage = true
        @scope.absolute_errors = true
        @scope.resizeTable = 0
        @scope.excel = @excel
        @scope.save = @save

        # This page doesn't use the sidebar
        App.sidebar?.close()
        App.angularSidebar?.close()

        @handleDaysToHarvest()


    ###
    Handle the preloaded data
    We have to preload via resolve in the router b/c Handsontables
    does weird things when you try to load the data after initiation
    ###
    handleDaysToHarvest: () =>
        @scope.setAlert(@days.status)

        if @days.status.type is 'success'
            @days = @days.data

            # Format the days so handsontables will accept it
            @raw_days = $.map @days.dth, (value, index) ->
                return [value]

            # Initiate handsontables
            @scope.table_settings =
                currentRowClassName: 'highlighted'
                currentColClassName: 'highlighted'
                data: @raw_days
                columns: ({ data: 'hybrid' + id + '.dth' } for id in @days.hybridIds )
                rowHeaders: @days.rowHeaders
                colHeaders: @days.colHeaders
                maxRows: @days.rowHeaders.length # Prevents adding new rows
                maxCols: @days.colHeaders.length # Prevents adding new cols
                beforeChange: (changes, source) ->
                    for cell in changes
                        # Must be a number, must be an integer, must be finite, must be between 0 and 200
                        if isNaN(parseFloat(cell[3])) or parseFloat(cell[3]) % 1 isnt 0 or parseInt(cell[3]) < 0 or parseInt(cell[3]) > 200
                            return false
                        else
                            if (parseFloat(cell[3]) is -0) or (parseFloat(cell[3]) is +0)
                                cell[3] = 0
                            col = cell[1].match(/.*[^.dth]/)
                            @getSourceDataAtRow(cell[0])[col[0]].changed = true

                    return true

    ###
    Save days to harvest
    ###
    save: () =>
        @scope.setAlert({ msg: 'Saving Days...', type: 'info' })
        changedData = []

        # Only collect days that have been changed
        for row in @raw_days
            for key, cell of row
                if cell.changed is true
                    changedData.push cell

        # JSONify the days and send save request
        days = JSON.stringify(changedData)

        @repo.save(days).then (response) =>
            jsr = response.data
            @scope.setAlert(jsr.status)

    ###
    Excel export
    ###
    excel: () =>
        @repo.excel()
